import { canGoBack } from "src/utils/navigation.utils";

import { BackButton } from "./BackButton";

export const BackButtonWithCondition = () => {
  return canGoBack() ? <BackButton /> : null;
};
